import { useEffect, useState } from "react";
import { getAccountDocumentsAsync } from "./../../../services/documentService";
import Pagination from "../../../components/common/Pagination";
import Table from "../../../components/common/Table";
import moment from "moment";

const DocumentsTable = ({ id, columns, tableOptions, onChange }) => {
  const [documents, setDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchDocuments = async () => {
      setIsLoading(true);

      const response = await getAccountDocumentsAsync(id, tableOptions);
      const { result, page, total_count } = response;

      const data = result.map((item) => {
        item["document_name"] = (
          <a
            className="hover:text-blue-400"
            href={item.s3_reference_name}
            rel="noreferrer"
            target="_blank"
          >
            {item.document_name}
          </a>
        );

        item["uploaded_on"] = moment(item.uploaded_on).format("LL");

        return item;
      });

      if (mounted) {
        setDocuments(data);
        setCurrentPage(page);
        setTotalCount(total_count);
        setIsLoading(false);
      }
    };

    fetchDocuments();

    return () => {
      mounted = false;
    };
  }, [id, tableOptions]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={documents}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default DocumentsTable;
